import { createTransform } from 'redux-persist'
import { PlanningRecordState, initialState } from './planningRecordSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  PlanningRecordState,
  Omit<PlanningRecordState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: PlanningRecordState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['planningRecord'],
  },
)
